import { RootState } from "store/store";

export const selectUsers = (state: RootState) => state.user.users;
export const selectFilterRoleMembers = (state: RootState) =>
  state.user.filterRoleMembers;
export const selectNonFilterRoleMembers = (state: RootState) =>
  state.user.nonFilterRoleMembers;
